import { StyleRules } from '@material-ui/core/styles';
import { TableCellClassKey } from '@material-ui/core/TableCell';

import { core as theme } from '../styles/core';

export const MuiTableCell: Partial<StyleRules<TableCellClassKey>> = {
  body: {
    color: theme.palette.grey[800],
  },
  head: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.grey.A200}`,
    color: theme.palette.grey[600],
    lineHeight: 1.5,
    padding: `${theme.spacing(2)}px`,
  },
  root: {
    borderBottom: 'none',
    padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
  },
  stickyHeader: {
    backgroundColor: theme.palette.common.white,
  },
};
